"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const Menu_1 = __importDefault(require("@mui/icons-material/Menu"));
const material_1 = require("@mui/material");
const react_router_1 = require("react-router");
const zustandStore_1 = require("../../../../zustandStore");
const WalletDetailsHeader = () => {
    const theme = (0, material_1.useTheme)();
    const navigate = (0, react_router_1.useNavigate)();
    const { headerName, previousPath } = (0, zustandStore_1.useZustand)(state => ({
        headerName: state.header.headerName,
        previousPath: state.wallet.previousPath,
    }));
    const { openSideMenuOnMobileView } = (0, zustandStore_1.useZustand)();
    return ((0, jsx_runtime_1.jsx)(material_1.Stack, { className: "main-header", "data-testid": "main-header", style: { zIndex: 0 }, children: (0, jsx_runtime_1.jsxs)(material_1.AppBar, { "ts-variant": "main-header", children: [(0, jsx_runtime_1.jsx)(material_1.Button, { "data-testid": "hamburger-btn", "ts-variant": "hamburger", onClick: () => openSideMenuOnMobileView(true), children: (0, jsx_runtime_1.jsx)(Menu_1.default, { style: { stroke: 'black' } }) }), (0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "header no-text-trunc", sx: {
                        width: 'calc(100% - 45px)',
                    }, children: headerName }), (0, jsx_runtime_1.jsx)(material_1.IconButton, { "aria-label": "close", onClick: () => {
                        navigate(previousPath);
                    }, sx: {
                        position: 'absolute',
                        right: theme.tsGoUnit.tsUnit,
                        padding: 0,
                        fontWeight: theme.typography.tsFontWeight.boldest,
                        color: theme.palette.tsGoColor.black,
                    }, children: (0, jsx_runtime_1.jsx)(Close_1.default, { sx: { fontWeight: theme.typography.tsFontWeight.boldest } }) })] }) }));
};
exports.default = WalletDetailsHeader;
